(function($, undefined) {
	'use strict';

	var showHiddenSearchResults = function() {
		var btn = $(this);
		var section = btn.closest('.search-results-section');
		var target = section.offset().top + section.outerHeight();
		var additionalOffset = $(window).scrollTop() > target ? 160 : 100;
		var time = 400;
		
		$('html, body').animate({ scrollTop: (target - additionalOffset) }, time);
		setTimeout(function() {
			section.find('.search-result_hidden').fadeIn(function() {
				$(this).removeClass('search-result_hidden');
				btn.fadeOut();
			});
		}, time - 200);
	};

	var init = function() {
		$('.search-results-section__see-all-btn').click(showHiddenSearchResults);
	};

	$(window).ready(function() {
		init();
	});
})(jQuery);
